// extracted by mini-css-extract-plugin
module.exports = {"tags":"SkillField_tags__3vBkC","item":"SkillField_item__2y07q","sending":"SkillField_sending__2Vk-k"};